import type { PopupConfig, PopupInstance } from './types';
import { Popup } from './popup';

class PopupManager {
	private popups: Map<number, Popup> = new Map();

	init(configs: PopupConfig[]): void {
		for (const config of configs) {
			if (!config.isActive || !config.formId) continue;

			const popup = new Popup(config);
			this.popups.set(config.feedId, popup);
			popup.init();
		}
	}

	show(feedId: number): void {
		this.popups.get(feedId)?.show();
	}

	hide(feedId: number): void {
		this.popups.get(feedId)?.hide();
	}

	getPopup(feedId: number): PopupInstance | undefined {
		return this.popups.get(feedId);
	}

	destroy(): void {
		for (const popup of this.popups.values()) {
			popup.destroy();
		}
		this.popups.clear();
	}
}

export const popupManager = new PopupManager();
